import { MARQUEE_ITEMS } from "./data";

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#0d0f17] py-5"
    >
      <div className="flex w-max animate-marquee items-center whitespace-nowrap">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {MARQUEE_ITEMS.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span className="px-8 font-display text-sm font-bold uppercase tracking-[0.3em] text-slate-500">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-blue-400/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
